import React, { createContext, useContext, useState } from 'react';
import { translations as nestedTranslations } from '../translations/index.js';

const LanguageContext = createContext();

export const translations = {
  id: {
    // Header & Nav
    nav_home: 'Beranda',
    nav_products: 'Produk & Layanan',
    nav_all_products: 'Semua Produk & Layanan',
    nav_solutions: 'Solusi Bahan Bangunan',
    nav_aggregate: 'Agregat & Material',
    nav_about: 'Tentang Kami',
    nav_locations: 'Lokasi Operasional',
    nav_certificates: 'Sertifikat & Penghargaan',
    nav_projects: 'Pelanggan & Proyek',
    nav_sustainability: 'Keberlanjutan',
    nav_news: 'Berita & Artikel',
    nav_contact: 'Kontak',
    search_placeholder: 'Cari produk, proyek, atau artikel...',
    contact_us_btn: 'Hubungi Kami',

    // Hero & Home
    hero_title_1: 'Solusi Beton & Konstruksi Terpercaya di Indonesia',
    hero_desc_1: 'Penyedia ready-mix, agregat, dan solusi beton teraplikasi dengan kualitas standar nasional dan internasional.',
    hero_title_2: 'Inovasi Beton Berkelanjutan untuk Masa Depan',
    hero_desc_2: 'Mendukung pembangunan ramah lingkungan melalui teknologi ramah iklim dan efisiensi material.',
    cta_explore_products: 'Lihat Produk',
    cta_consultation: 'Konsultasi Gratis',
    cta_view_projects: 'Lihat Proyek Mahakarya',
    cta_download_brochure: 'Unduh Brosur',
    cta_contact_team: 'Hubungi Tim Kami',
    cta_view_all: 'Lihat Selengkapnya',
    cta_search: 'Cari',

    // Section Titles
    section_about_title: 'Sekilas Tentang Solusi Bangun Beton',
    section_about_desc: 'Solusi Bangun Beton (bagian dari SIG) adalah mitra terpercaya dalam penyediaan produk beton siap pakai (ready-mix), agregat berkualitas tinggi, serta solusi beton khusus untuk berbagai sektor pembangunan.',
    section_solutions_title: 'Solusi Bahan Bangunan',
    section_solutions_subtitle: 'Inovasi beton presisi yang dirancang khusus untuk memenuhi tantangan proyek konstruksi Anda.',
    section_featured_projects: 'Pelanggan & Proyek Mahakarya',
    section_projects_subtitle: 'Bukti rekam jejak dan kredibilitas kami dalam mendukung infrastruktur dan bangunan penting di Indonesia.',
    section_locations_title: 'Jangkauan Lokasi Operasional',
    section_locations_subtitle: 'Temukan batching plant dan tambang agregat terdekat dari lokasi proyek Anda.',
    section_sustainability_title: 'Komitmen Keberlanjutan',
    section_sustainability_subtitle: 'Membangun negeri dengan solusi beton rendah karbon dan pengelolaan lingkungan yang bertanggung jawab.',
    section_news_title: 'Berita & Siaran Pers',

    // Footer
    footer_tagline: 'Solusi Beton Terintegrasi dan Berkelanjutan untuk Indonesia.',
    footer_member_sig: 'Member of SIG (PT Semen Indonesia (Persero) Tbk)',
    footer_quick_links: 'Tautan Cepat',
    footer_products: 'Produk Utama',
    footer_contact_info: 'Informasi Kontak',
    footer_address: 'Gedung Menara BPPT II, Lt. 15, Jl. M.H. Thamrin No.8, Jakarta Pusat 10340',
    footer_privacy: 'Kebijakan Privasi',
    footer_rights: 'Hak Cipta Dilindungi.',

    // Common UI Labels
    category: 'Kategori',
    location: 'Lokasi',
    year: 'Tahun',
    client: 'Klien',
    contractor: 'Kontraktor',
    product_specs: 'Spesifikasi Teknis',
    key_advantages: 'Keunggulan Utama',
    applications: 'Aplikasi & Penggunaan',
    related_products: 'Produk Terkait',
    related_projects: 'Proyek Terkait',
    filter_all: 'Semua',
    search_results: 'Hasil Pencarian',
    no_results: 'Tidak ada data yang ditemukan.',
    press_release: 'Siaran Pers',
    articles: 'Artikel',
    read_more: 'Baca Selengkapnya',
    share: 'Bagikan',
    download_pdf: 'Unduh PDF',
    preview_certificate: 'Pratinjau Sertifikat',

    // Contact Form
    form_title: 'Kirimkan Pesan Anda',
    form_subtitle: 'Tim kami siap membantu kebutuhan solusi beton dan agregat untuk proyek Anda.',
    form_name: 'Nama Lengkap',
    form_email: 'Alamat Email',
    form_phone: 'Nomor Telepon / WhatsApp',
    form_purpose: 'Tujuan Pertanyaan',
    form_purpose_select: '-- Pilih Tujuan --',
    form_purpose_product: 'Informasi Produk & Harga',
    form_purpose_order: 'Pemesanan & Pengecekan Status',
    form_purpose_career: 'Karir & Keanggotaan',
    form_purpose_other: 'Lainnya',
    form_message: 'Pesan / Pertanyaan',
    form_consent: 'Saya menyetujui Kebijakan Privasi dan pemrosesan data untuk kontak bisnis.',
    form_submit: 'Kirim Pesan',
    form_submitting: 'Mengirim...',
    form_success: 'Terima kasih! Pesan Anda telah berhasil terkirim. Tim kami akan segera menghubungi Anda.',
  },
  en: {
    // Header & Nav
    nav_home: 'Home',
    nav_products: 'Products & Services',
    nav_all_products: 'All Products & Services',
    nav_solutions: 'Building Solutions',
    nav_aggregate: 'Aggregates & Materials',
    nav_about: 'About Us',
    nav_locations: 'Operational Locations',
    nav_certificates: 'Certificates & Awards',
    nav_projects: 'Clients & Projects',
    nav_sustainability: 'Sustainability',
    nav_news: 'News & Articles',
    nav_contact: 'Contact',
    search_placeholder: 'Search products, projects, or articles...',
    contact_us_btn: 'Contact Us',

    // Hero & Home
    hero_title_1: 'Trusted Concrete & Construction Solutions in Indonesia',
    hero_desc_1: 'Provider of ready-mix, aggregates, and applied concrete solutions adhering to top national and international standards.',
    hero_title_2: 'Sustainable Concrete Innovation for the Future',
    hero_desc_2: 'Supporting eco-friendly construction through climate-smart technologies and material efficiency.',
    cta_explore_products: 'Explore Products',
    cta_consultation: 'Free Consultation',
    cta_view_projects: 'View Masterpiece Projects',
    cta_download_brochure: 'Download Brochure',
    cta_contact_team: 'Contact Our Team',
    cta_view_all: 'View All',
    cta_search: 'Search',

    // Section Titles
    section_about_title: 'About Solusi Bangun Beton',
    section_about_desc: 'Solusi Bangun Beton (part of SIG) is a trusted partner delivering ready-mix concrete, high-quality aggregates, and specialized concrete solutions across all construction sectors.',
    section_solutions_title: 'Building Solutions',
    section_solutions_subtitle: 'Precision engineered concrete innovations tailored to satisfy complex project demands.',
    section_featured_projects: 'Clients & Masterpiece Projects',
    section_projects_subtitle: 'Demonstrating our track record and credibility in major infrastructure and architectural landmarks.',
    section_locations_title: 'Operational Footprint',
    section_locations_subtitle: 'Locate nearby batching plants and aggregate mines closest to your project site.',
    section_sustainability_title: 'Commitment to Sustainability',
    section_sustainability_subtitle: 'Building the nation with low-carbon concrete solutions and responsible environmental stewardship.',
    section_news_title: 'News & Press Releases',

    // Footer
    footer_tagline: 'Integrated and Sustainable Concrete Solutions for Indonesia.',
    footer_member_sig: 'Member of SIG (PT Semen Indonesia (Persero) Tbk)',
    footer_quick_links: 'Quick Links',
    footer_products: 'Key Products',
    footer_contact_info: 'Contact Information',
    footer_address: 'BPPT II Building, 15th Floor, Jl. M.H. Thamrin No.8, Central Jakarta 10340',
    footer_privacy: 'Privacy Policy',
    footer_rights: 'All Rights Reserved.',

    // Common UI Labels
    category: 'Category',
    location: 'Location',
    year: 'Year',
    client: 'Client',
    contractor: 'Contractor',
    product_specs: 'Technical Specifications',
    key_advantages: 'Key Advantages',
    applications: 'Applications & Uses',
    related_products: 'Related Products',
    related_projects: 'Related Projects',
    filter_all: 'All',
    search_results: 'Search Results',
    no_results: 'No records found.',
    press_release: 'Press Release',
    articles: 'Articles',
    read_more: 'Read More',
    share: 'Share',
    download_pdf: 'Download PDF',
    preview_certificate: 'Preview Certificate',

    // Contact Form
    form_title: 'Send Us a Message',
    form_subtitle: 'Our engineering experts are ready to consult on your concrete and aggregate requirements.',
    form_name: 'Full Name',
    form_email: 'Email Address',
    form_phone: 'Phone / WhatsApp Number',
    form_purpose: 'Inquiry Purpose',
    form_purpose_select: '-- Select Purpose --',
    form_purpose_product: 'Product Info & Pricing',
    form_purpose_order: 'Order & Status Check',
    form_purpose_career: 'Career & Partnership',
    form_purpose_other: 'Others',
    form_message: 'Message / Inquiry',
    form_consent: 'I agree to the Privacy Policy and data processing for business inquiry.',
    form_submit: 'Submit Message',
    form_submitting: 'Submitting...',
    form_success: 'Thank you! Your message has been submitted. Our team will contact you shortly.',
  }
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('sbb_lang') || 'id');

  const toggleLanguage = (newLang) => {
    const selected = newLang || (lang === 'id' ? 'en' : 'id');
    setLang(selected);
    localStorage.setItem('sbb_lang', selected);
  };

  const t = (key) => {
    // 1. Coba flat key dulu (untuk key-key baru di LanguageContext)
    const flatValue = translations[lang]?.[key] ?? translations['id']?.[key];
    if (flatValue !== undefined && flatValue !== null) return flatValue;

    // 2. Coba dot-notation di nested translations (untuk Cart, dll.)
    const parts = key.split('.');
    const resolveNested = (obj) => parts.reduce((acc, part) => acc?.[part], obj);
    const nestedValue = resolveNested(nestedTranslations[lang]) ?? resolveNested(nestedTranslations['id']);
    return nestedValue ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
